import { createApp } from 'vue';
import VueTheMask from 'vue-the-mask';
import App from './App.vue';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as Icons from '@element-plus/icons-vue';

import router from './router';
import store from './store';

const app = createApp(App);

// Registra todos os ícones globalmente
for (const [key, component] of Object.entries(Icons)) {
    app.component(key, component);
}

app.use(ElementPlus);
app.use(router);
app.use(store);
app.use(VueTheMask);

window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation();
  }
});

app.mount('#app');
